import { offset, shift, useFloating } from "@floating-ui/react-dom";
import { getZoomLevel } from "@utils/zoom.utils";
import React from "react";
import ReactDOM from "react-dom";

import TestIds from "../testIds";
import { SHELL_NOTIFICATION_ID } from "../views/main/Shell.types";
import Notification from "./Notification";
import { INotification } from "./Notifications";
import { StyledNotificationAlert } from "./Notifications.styles";

interface IProps extends INotification {
    isPriorityNotification?: boolean;
    onClose?: () => void;
    onFadeEnd?: () => void;
}

const NotificationAlert = React.memo((props: React.PropsWithChildren<IProps>) => {
    const notificationButton = document.getElementById(SHELL_NOTIFICATION_ID);

    const zoom = getZoomLevel();
    const zoomCorrectionMiddleware = {
        name: 'zoomCorrection',
        fn({ x, y }: { x: number; y: number }) {
            return {
                x: x / zoom,
                y: y / zoom,
            };
        },
    };

    const { floatingStyles, refs } = useFloating({
        placement: "right",
        middleware: [
            offset({ mainAxis: 20 }),
            shift({ padding: 19, rootBoundary: "viewport" }),
            zoomCorrectionMiddleware
        ]
    });

    refs.setReference(notificationButton);

    const { onFadeEnd, isPriorityNotification, onClose, ...passProps } = props;

    return ReactDOM.createPortal((
        <StyledNotificationAlert ref={refs.setFloating}
                                 style={floatingStyles}
                                 useFade={!isPriorityNotification}
                                 onAnimationEnd={onFadeEnd}
                                 data-testid={TestIds.NotificationAlert}>
            <Notification {...passProps}
                          isUnread={false /* we don't show unread state in alert */}
                          onCloseButtonClick={onClose} />
        </StyledNotificationAlert>
    ), document.getElementById("context-menu-root"));
});

export default NotificationAlert;
